import { Component } from '@angular/core';

@Component({
  selector: 'lib-adc-lib',
  template: `
    <p>
      adc-lib works!
    </p>
  `,
  styles: [
  ]
})
export class AdcLibComponent {

}
